module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic.38beda31.ttf";